import type { Industry } from '../types/content'

export const industries: Industry[] = [
  {
    id: 'remote',
    label: 'Remote & Off-Grid Power',
    who: 'Stations, camps, remote communities, telecom and infrastructure sites.',
    pressure:
      'Every litre of diesel is trucked in. Generators run around the clock, and one missed delivery or breakdown can take the whole site down.',
    fit: 'A containerised system pairs solar with storage so your generators run less, and it arrives ready to connect.',
    pressures: ['High diesel reliance', 'Remote reliability risk', 'Integration complexity'],
    startWith: { label: 'All-in-One Power System', href: '#flagship' },
  },
  {
    id: 'disaster',
    label: 'Disaster Response',
    who: 'Emergency management agencies, councils, relief and recovery operators.',
    pressure:
      'When the grid fails, evacuation centres, comms and medical points need power fast, and wherever the event happens.',
    fit: 'A transportable system that crews can set up quickly. The All-in-One takes 3–4 hours the first time and about 30 minutes after that.',
    pressures: ['Fast deployment needs', 'Remote reliability risk', 'Tender & compliance documentation'],
    startWith: { label: 'Disaster Response System brochure', href: '#resources' },
  },
  {
    id: 'agriculture',
    label: 'Agriculture',
    who: 'Pastoral stations, irrigators, cool rooms and on-farm processing.',
    pressure:
      'Pumps, cool rooms and sheds sit at the end of long, unreliable lines or run on generators, and demand changes with the season.',
    fit: 'Solar plus storage sized to your load, in a durable package with components selected for Australian conditions.',
    pressures: ['High diesel reliance', 'Remote reliability risk', 'Integration complexity'],
    startWith: { label: 'Standalone PV Power Generating System', href: '#resources' },
  },
  {
    id: 'utilities',
    label: 'Utilities & Microgrids',
    who: 'Network operators, solar farm owners and microgrid developers.',
    pressure:
      'Weak lines at the edge of the grid, solar that peaks when demand doesn’t, and pressure to firm up renewable supply.',
    fit: 'Long-duration storage for solar farms and grid support, built from containerised blocks and sized to the project.',
    pressures: ['Integration complexity', 'Tender & compliance documentation'],
    startWith: { label: 'MWh Energy Storage System brochure', href: '#resources' },
  },
  {
    id: 'defence',
    label: 'Defence & Critical Infrastructure',
    who: 'Defence primes, communications, water and essential-service operators.',
    pressure:
      'Power that can’t fail, paperwork that has to stand up to scrutiny, and sites that are hard to reach.',
    fit: 'Resilient backup power, plus a proposal and documentation pack prepared for formal procurement.',
    pressures: ['Remote reliability risk', 'Tender & compliance documentation', 'Fast deployment needs'],
    startWith: { label: 'Talk to an engineer', href: '#contact' },
  },
]
